import { render, staticRenderFns } from "./MsgRecall.vue?vue&type=template&id=3f503130&scoped=true&"
import script from "./MsgRecall.vue?vue&type=script&lang=js&"
export * from "./MsgRecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f503130",
  null
  
)

export default component.exports